/* eslint-disable react/react-in-jsx-scope */
import { Children } from 'react';
import { FiArrowUpCircle, FiArrowDownCircle, FiCircle } from 'react-icons/fi';
import {
  AiChatIcon,
  AiTrackerIcon,
  BacklinksIcon,
  ContentToolsIcon,
  IndexerIcon,
  KeywordResearchIcon,
  KeywordTrackerIcon,
  PageAnalyzeIcon,
  ReportingIcon,
  SerpToolsIcon,
  SiteAuditIcon
} from '@/components/icons/tools';
import { backlinkTabRoutes } from '@/app/BacklinkNew/utils/backlinkRoutes';

const accountServerUrl = (
  import.meta as ImportMeta & {
    env: Record<string, string | undefined>;
  }
).env.VITE_ACCOUNT_SERVER_URL;

export const dashboardRoutes = {
  label: 'Dashboard',
  labelDisable: true,
  children: [
    {
      name: 'پیشخوان',
      to: '/',
      exact: true,
      icon: 'chart-pie',
      active: true
    },
    {
      name: 'دامنه',
      to: '/domains/',
      exact: false,
      icon: 'globe',
      // badge: {
      //   type: 'success',
      //   text: 'به زودی'
      // },
      active: false,
      disabled: false
    }
  ]
};

export const aiAssistantRoutes = {
  label: 'دستیار AI',
  children: [
    {
      name: 'چت جدید',
      to: '/chat',
      action: 'mcpNewChat',
      exact: true,
      icon: <AiChatIcon />,
      active: true
    },
    {
      name: 'سابقه چت',
      icon: 'history',
      active: true,
      defaultOpen: true,
      children: []
    },
    {
      name: 'divider-after-history',
      divider: true
    },
    {
      name: 'مهارت‌ها',
      to: '/chat/skills',
      exact: true,
      icon: 'layer-group',
      active: true
    },
    {
      name: 'قالب‌های پرامپت',
      to: '/chat/prompts',
      exact: true,
      icon: 'file-alt',
      active: true,
      disabled: true,
      badge: {
        type: 'success',
        text: 'به زودی'
      }
    },
    {
      name: 'خودکارسازی',
      to: '/chat/automation',
      exact: true,
      icon: 'diagram-project',
      active: true,
      disabled: true,
      badge: {
        type: 'success',
        text: 'به زودی'
      }
    },
    {
      name: 'اتصال MCP',
      to: '/chat/mcp-connection',
      exact: true,
      icon: 'plug',
      active: true,
      disabled: true,
      badge: {
        type: 'success',
        text: 'به زودی'
      }
    },
    {
      name: 'تنظیمات',
      to: '/chat/settings',
      exact: true,
      icon: 'cog',
      active: true
    }
  ]
};

export const toolRoutes = {
  label: 'ابزارها',
  labelDisable: false,
  children: [
    {
      name: 'ردیاب کلمات',
      active: true,
      icon: <KeywordTrackerIcon />,
      children: [
        // {
        //   name: 'نمای کلی',
        //   to: '/keyword-tracker/overview',
        //   helper: (
        //     <>به زودی تمام بخش های ردیاب کلمات به پنل جدید منتقل خواهد شد.</>
        //   ),
        //   disabled: true,
        //   badge: {
        //     type: 'info',
        //     text: 'به زودی'
        //   }
        // },
        {
          name: 'مدیریت کلمات',
          to: '/keyword-tracker/keywords',
          helper: (
            <>
              قلب ردیاب کلمات اینجاست! پیشنهاد می‌کنم حتما{' '}
              <a
                target="_blank"
                rel="noreferrer noopener"
                href="https://help.mizfa.tools/video-keywords-tools/"
              >
                {' '}
                ویدیوی آموزشی ردیاب کلمات{' '}
              </a>{' '}
              رو ببین. همینطور اگه قصد داری مثل یه متخصص حرفه‌ای سئو از این
              ابزار استفاده کنی،
              <a
                target="_blank"
                rel="noreferrer noopener"
                href="https://help.mizfa.tools/feature-table/"
              >
                {' '}
                امکانات جدول میزفا تولز{' '}
              </a>{' '}
              رو حتما بررسی کن.{' '}
              <a
                target="_blank"
                rel="noreferrer noopener"
                href="https://help.mizfa.tools/category/faq/%d8%b3%d9%88%d8%a7%d9%84%d8%a7%d8%aa-%d9%85%d8%aa%d8%af%d8%a7%d9%88%d9%84-%d8%a7%d8%a8%d8%b2%d8%a7%d8%b1-%d8%b1%d8%af%db%8c%d8%a7%d8%a8-%da%a9%d9%84%d9%85%d8%a7%d8%aa/"
              >
                {' '}
                سوالات متداول{' '}
              </a>{' '}
              این بخش هم می‌تونه خیلی بهت کمک کنه.
            </>
          ),
        },
        // {
        //   name: 'تحلیل هوشمند',
        //   to: '/keyword-tracker/insight',
        //   helper: (
        //     <>به زودی تمام بخش های ردیاب کلمات به پنل جدید منتقل خواهد شد.</>
        //   ),
        //   disabled: true,
        //   badge: {
        //     type: 'info',
        //     text: 'به زودی'
        //   }
        // },
        {
          name: 'آرایش رتبه',
          to: '/keyword-tracker/rank-historical',

          helper: (
            <>
              برای مقایسه رتبه کلمات در یک بازه زمانی به‌صورت بصری، تب "آرایش
              رتبه" می‌تونه خیلی بهتون کمک کنه. در کل، تحلیل درست ممکنه زمان‌بر
              باشه، ولی با استفاده از آرایش رتبه، می‌تونید خیلی سریع‌تر تحلیل
              کنید و تغییرات رتبه کلمات رو راحت‌تر و با سرعت بیشتری متوجه بشید.
            </>
          ),
        },
        {
          name: 'نقشه کلمات',
          to: '/keyword-tracker/map',
          disabled: false,
          helper: (
            <>
              با استفاده از تب "نقشه کلمات" می‌تونید خیلی سریع و راحت، بدون نیاز
              به صرف زمان برای تحلیل، وضعیت سایتتون رو در کلمات کلیدی که جستجوی
              بالا یا پایین دارن، متوجه بشید. یعنی می‌تونید متوجه بشید که کدوم
              کلمات بیشترین یا کمترین رشد و افت رو داشتن. برای اطلاعات بیشتر و
              تحلیل‌های دقیق‌تر، می‌تونید از{' '}
              <a
                target="_blank"
                rel="noreferrer noopener"
                href="https://help.mizfa.tools/word-map-tab/"
              >
                {' '}
                این لینک{' '}
              </a>{' '}
              استفاده کنید.
            </>
          ),
        },
        {
          name: 'دسته',
          to: '/keyword-tracker/groups',
          disabled: false,
          helper: (
            <>
              برای دسته‌بندی کلمات کلیدی، می‌تونی از دسته‌بندی‌ها استفاده کنی.
              مثلاً اگر فروشگاه لوازم دیجیتال داری، دسته‌های "موبایل سامسونگ" و
              "موبایل هوآوی" می‌تونن انتخاب‌های خوبی برای نظم دادن به کلماتت
              باشن. با این کار، تحلیل کردن خیلی راحت‌تر می‌شه. راهنمای مربوط به
              دسته‌بندی رو می‌تونی در{' '}
              <a
                target="_blank"
                rel="noreferrer noopener"
                href="https://help.mizfa.tools/category/mizfa-tracker-pro/topic-keyword/"
              >
                {' '}
                این لینک{' '}
              </a>{' '}
              مشاهده کنی.
            </>
          ),
        },
        {
          name: 'برچسب',
          to: '/keyword-tracker/tags',
          disabled: false,
          helper: (
            <>
              حرفه‌ای‌ها از برچسب استفاده میکنن. به‌عنوان مثال با استفاده از
              برچسب می‌تونی همه کلمات کلیدی رو در سه سطح تقسیم‌بندی کنی: اولویت
              مهم، اولویت متوسط و اولویت ضعیف. با این کار، می‌تونی به کارهات در
              سئو نظم بیشتری بدی. حتماً نمونه برچسب‌های کاربردی رو در
              <a
                target="_blank"
                rel="noreferrer noopener"
                href="https://help.mizfa.tools/functional-labels/"
              >
                {' '}
                این لینک
              </a>{' '}
              مطالعه کن.
            </>
          ),
        },
        {
          name: 'صفحه هدف',
          to: '/keyword-tracker/landing-urls',
          disabled: false,
          helper: (
            <>
              صفحه هدف یک امکان جذاب برای پیدا کردن{' '}
              <a
                target="_blank"
                rel="noreferrer noopener"
                href="https://help.mizfa.tools/reasons-for-inconsistency-with-landing-page/"
              >
                {' '}
                مشکل مغایرت{' '}
              </a>{' '}
              و{' '}
              <a
                target="_blank"
                rel="noreferrer noopener"
                href="https://mizfa.tools/article/keyword-cannibalization/"
              >
                {' '}
                همنوع خواری{' '}
              </a>{' '}
              هست، همچنین، تعیین صفحه هدف توسط شما کمک می‌کند تا بتونید کلمات هر
              صفحه رو به‌خوبی مدیریت کنید. برای اطلاعات بیشتر درباره صفحه هدف،
              حتماً{' '}
              <a
                target="_blank"
                rel="noreferrer noopener"
                href="https://help.mizfa.tools/category/mizfa-tracker-pro/landgin-page/"
              >
                {' '}
                این لینک{' '}
              </a>{' '}
              رو بررسی کن.
            </>
          ),
        },
        {
          name: 'رقیب',
          to: '/keyword-tracker/competitors',
          disabled: false,
          helper: (
            <>
              برای مقایسه سایت خودتون با رقبا، این بخش خیلی بهتون کمک می‌کنه.
              پیشنهاد می‌کنیم حداقل هفته‌ای یک بار به این تب سر بزنید و با
              استفاده از ویدیوهای آموزشی یا به کمک یک متخصص سئو، تحلیل و آنالیز
              لازم رو انجام بدید. اگه این کار رو نکنید، در واقع دارید به رقباتون
              لطف می‌کنید! جهت کسب اطلاعات بیشتر روی
              <a
                target="_blank"
                rel="noreferrer noopener"
                href="https://help.mizfa.tools/category/mizfa-tracker-pro/competitor/"
              >
                {' '}
                این لینک{' '}
              </a>{' '}
              کلیک کنید.
            </>
          ),
        }
      ]
    },
    {
      name: 'ردیاب AI',
      active:  false,
      disabled: true,
      icon: <AiTrackerIcon />,
      badge: {
        type: 'info',
        text: 'به زودی'
      },
      children: [
        {
          name: 'داشبورد',
          to: '/tracker-ai/overview',
          helper: (
            <>
              نمای کلی دیده‌شدن برندتان در پاسخ‌های AI؛ شاخص‌های اصلی، مقایسه با
              رقبا، برندهای پرتکرار و عملکرد اخیر پرامپت‌ها را یک‌جا ببینید و با
              فیلترها تحلیل را دقیق‌تر کنید.
            </>
          )
        },
        {
          name: 'پرامپت‌ها',
          to: '/tracker-ai/prompts',
          helper: (
            <>
              پرامپت‌های ردیابی را بسازید، اجرا کنید و نتیجه هر مدل را ببینید؛ از
              اینجا می‌توانید جزئیات پاسخ، برندهای شناسایی‌شده و تاریخچه اجرا را
              بررسی کنید.
            </>
          )
        },
        {
          name: 'تاپیک‌ها',
          to: '/tracker-ai/topics',
          helper: (
            <>
              پرامپت‌ها را در تاپیک‌های موضوعی گروه‌بندی کنید و عملکرد دیده‌شدن
              هر حوزه را جداگانه بسنجید تا نقاط قوت و ضعف برندتان روشن‌تر شود.
            </>
          )
        },
        {
          name: 'اجراها',
          to: '/tracker-ai/executions',
          helper: (
            <>
              تاریخچه اجرای پرامپت‌ها روی مدل‌های AI را ببینید؛ وضعیت هر اجرا،
              پاسخ مدل و برندهای استخراج‌شده را فیلتر و جزئیاتش را بررسی کنید.
            </>
          )
        },
        {
          name: 'دیده‌شدن',
          to: '/tracker-ai/visibility',
          helper: (
            <>
              دیده‌شدن برند و رقبا را با ترند زمانی، رتبه میانگین و مقایسه بین
              مدل‌ها تحلیل کنید تا بفهمید کجا جلوتر یا عقب‌تر هستید.
            </>
          )
        },
        {
          name: 'رقبا',
          to: '/tracker-ai/competitors',
          helper: (
            <>
              رقبای تحت پایش را مدیریت کنید و دیده‌شدن، رتبه و منابع آن‌ها را با
              برند خودتان مقایسه کنید تا شکاف رقابتی را پیدا کنید.
            </>
          )
        },
        {
          name: 'منابع',
          to: '/tracker-ai/sources',
          helper: (
            <>
              دامنه‌ها و Citationهایی که AI در پاسخ‌ها به آن‌ها ارجاع می‌دهد را
              ببینید؛ نوع منابع، پوشش و روند استفاده را برای فرصت‌های محتوایی
              بررسی کنید.
            </>
          )
        },
        {
          name: 'تنظیمات',
          to: '/tracker-ai/settings',
          helper: (
            <>
              دامنه، نام‌های مستعار برند، رقبا، تاپیک‌ها و مدل پیش‌فرض پروژه را
              تنظیم کنید تا شناسایی برند در پاسخ‌های AI دقیق‌تر شود.
            </>
          )
        }
      ]
    },
    {
      name: 'تحقیق کلمات',
      icon: <KeywordResearchIcon />,
      children: [
        {
          name: 'کلمات مرتبط',
          to: '/keyword-research/massive',
          helper: (
            <>
              تب کلمات مرتبط به صورت خودکار (هر ۲۴ ساعت یک بار) و براساس کلماتی
              که در ابزار ردیاب کلمات اضافه کرده باشید، به‌روزرسانی میشه. برای
              افزایش تعداد کلمات مرتبط در این تب، دو عامل اثرگذار هست: تعداد
              کلمات در ابزار ردیاب کلمات و تاریخچه استفاده از آن ابزار. اطلاعات
              بیشتر درباره این تب در{' '}
              <a
                target="_blank"
                rel="noreferrer noopener"
                href="https://help.mizfa.tools/related-searches-google/"
              >
                {' '}
                این لینک{' '}
              </a>{' '}
              موجود هست.
            </>
          ),
        },
        {
          name: 'کلمات AI',
          to: '/keyword-research/ai-keywords/history',
          helper:
            'در تب «کلمات AI»، می‌تونید با کمک مدل هوش مصنوعی‌ای که در تنظیمات تعریف کردید، ایده‌های دقیق و کاربردی برای تحقیق کلمات بگیرید. ترکیب پیشنهادهای AI با داده‌های واقعی سئوی میزفا تولز، می‌تونه یک مزیت جدی برای رشد سایتتون باشه.',
          disabled: false,
          badge: {
            type: 'success',
            text: 'جدید'
          }
        },
        {
          name: 'کلمات GSC',
          to: '/keyword-research/keyword-gsc',
          helper: (
            <>
              به کمک تب کلمات GSC (مخفف Google Search Console) میتونید تمام
              کلماتی که داخل سرچ کنسول دارید رو بدست بیارید. (برای دور زدن
              محدودیت نمایش تعداد query در سرچ کنسول این تب مناسبه)
            </>
          ),
          disabled: false
        },
        {
          name: 'کیورد پلنر',
          to: '/keyword-research/planner',
          helper: (
            <>
              همانند ابزار کیورد پلنر گوگل هست، با این تفاوت که ایرادات کیورد
              پلنر گوگل مثل عدم نمایش دقیق میزان جستجوی کلمه رو نداره و امکاناتی
              جدید مثل نمایش CTR رو داره. به کمک تب کیورد پلنر میزفا تولز شما
              می‌تونید یک کلمه بدید و در عوض صدها کلمه مرتبط به همراه میزان
              جستجو به شما نمایش بده.
            </>
          ),
          disabled: false,
        },
        {
          name: 'کیورد گپ',
          to: '/keyword-research/keyword-gap',
          helper: (
            <>
              کیورد گپ یک ابزار حرفه‌ای برای تحلیل و بررسی کلمات دامنه شما به
              همراه رقبا هست، به شما پیشنهادات کاربردی میده تا متوجه نقاط قوت و
              ضعف سایت بشید و در صورت استفاده درست به رشد وب‌سایت شما کمک زیادی
              میکنه.
            </>
          ),
          disabled: false
        },
        {
          name: 'کلمات رقیب',
          to: '/keyword-research/competitors',
          helper: (
            <>
              در بخش کلمات رقیب، کافیه دامنه یا نشانی رقیب رو در باکس جستجوی
              پایین وارد کنی تا بتونی رتبه و صفحه‌ای که رقیب در آن کلمه در نتایج
              گوگل بالا هست رو مشاهده کنی.
            </>
          ),
          disabled: false,
        },
        {
          name: 'میزان جستجو',
          to: '/keyword-research/search-volume',
          helper: (
            <>
              برای پیدا کردن میزان جستجوی ماهانه کلمات دلخواه مناسب هست. مثلا
              کلماتی که قصد دارید در آینده برای یک پروژه کار کنید، یا کلماتی که
              داخل سرچ کنسول گوگل دارید یا کلماتی که داخل تب کلمات انبوه میزفا
              تولز پیدا میکنید رو وارد این بخش کنید تا بتونید میزان جستجوی دقیق
              ماهانه (و سالانه به همراه مقایسه) کلمات رو متوجه بشید.
            </>
          ),
          disabled: false,
        },
        {
          name: 'خوشه بندی',
          to: '/keyword-research/clustering',
          helper: (
            <>
              خوشه بندی کلمات (Keyword Clusters) به شما کمک میکنه تا کلماتی که
              دارید رو گروه‌بندی کنید، مخصوصا وقتی تعداد کلمات بالا دارید، بسیار
              زمان‌بر هست که کلمات مشابه رو چشمی بررسی کنید و گروه‌بندی کنید.
              مثلا شما می‌تونید هزاران کلمه کلیدی که از طریق سرچ کنسول یا از
              طریق کلمات انبوه میزفا تولز پیدا می‌کنید رو در این بخش گروه‌بندی
              کنید.
            </>
          )
        }

        // {
        //   name: 'ترکیب کلمات',
        //   to: '/keyword-research/combination',
        //   helper: (
        //     <>
        //       در تب صفحات براساس بودجه خزشی که دارید صفحات شما با دقت بالا بررسی
        //       شده، اطلاعات هر صفحه به صورت ستون‌ قابل نمایش هست، ستون‌ها
        //       گروه‌بندی شدن تا بتونید براساس داده‌های تمیزی که وجود داره یک
        //       بررسی عالی داشته باشید. همچنین می‌تونید از فیلتر پیشرفته براساس
        //       نیازهاتون صفحات رو فیلتر کنید. راستی هر ستون راهنما داره.
        //     </>
        //   ),
        //   disabled: true,
        // }
      ],
      active: true
    },
    {
      name: 'ابزار محتوا',
      icon: <ContentToolsIcon />,
      active: true,
      children: [
        {
          name: 'تحلیل AI',
          active: true,
          badge: {
            type: 'success',
            text: 'جدید'
          },
          helper: (
            <>
              این ابزار محتوای صفحه‌ی شما را از نظر سئو، ساختار، چگالی کلمات
              کلیدی، لینک‌سازی، تصاویر و عناصر فنی تحلیل می‌کند و یک گزارش کامل
              ارائه می‌ده تا بتونید نقاط قوت و ضعف صفحه‌تان را به‌طور دقیق
              مشاهده کنید.
            </>
          ),
          children: [
            {
              name: 'تاریخچه',
              to: '/content-tools/ai-analysis/history',
              helper: (
                <>
                  در تاریخچه می‌توانید تحلیل‌های قبلی را ببینید، دوباره اجرا کنید
                  یا گزارش جدید بسازید.
                </>
              )
            },
            {
              name: 'نمای کلی',
              to: '/content-tools/ai-analysis/overview',
              helper: (
                <>
                  نمای کلی خلاصه‌ای از امتیاز سئو، شباهت محتوا و وضعیت صفحه را
                  در یک نگاه نشان می‌دهد.
                </>
              )
            },
            {
              name: 'تحلیل سئو',
              to: '/content-tools/ai-analysis/seo',
              helper: (
                <>
                  در این بخش گزارش کامل سئوی محتوا و امتیاز معیارهای صفحه را
                  می‌بینید.
                </>
              )
            },
            {
              name: 'تحلیل EEAT',
              to: '/content-tools/ai-analysis/eeat',
              badge: {
                type: 'success',
                text: 'جدید'
              },
              helper: (
                <>
                  تجربه، تخصص، اعتبار و اعتماد محتوا را بر اساس چارچوب E-E-A-T
                  که گوگل در 2025 در یک{' '}
                  <a
                    target="_blank"
                    rel="noreferrer noopener"
                    href="https://static.googleusercontent.com/media/guidelines.raterhub.com/en//searchqualityevaluatorguidelines.pdf"
                  >
                    راهنمای 182 صفحه‌ای
                  </a>{' '}
                  معرفی کرد ارزیابی می‌کند.
                </>
              )
            },
            {
              name: 'تحلیل GEO',
              to: '/content-tools/ai-analysis/geo',
              badge: {
                type: 'success',
                text: 'جدید'
              },
              helper: (
                <>
                  تب تحلیل GEO نشان می‌دهد صفحه چقدر برای دیده‌شدن در پاسخ‌های
                  هوش مصنوعی مثل ChatGPT Search، Perplexity و نمای کلی هوش
                  مصنوعی گوگل (AI Overview) آماده‌ست؛ از جمله قابلیت استفاده از
                  محتوا در پاسخ‌های AI، وضوح پاسخ و ساختار، کیفیت شواهد و منابع،
                  هویت و اعتبار، و دسترسی فنی. راهنمای کامل را در{' '}
                  <a
                    target="_blank"
                    rel="noreferrer noopener"
                    href="https://help.mizfa.tools/geo-analysis-tab/"
                  >
                    این صفحه
                  </a>{' '}
                  ببینید.
                </>
              )
            },
            {
              name: 'تشخیص AI',
              to: '/content-tools/ai-analysis/detector',
              badge: {
                type: 'success',
                text: 'جدید'
              },
              helper: (
                <>
                  میزان شباهت نوشتار صفحه به محتوای انسانی یا تولیدشده با AI را
                  بررسی می‌کند.
                </>
              )
            }
          ]
        },
        {
          name: 'شاه محتوا',
          to: '#!',
          disabled: true,
          badge: {
            type: 'success',
            text: 'به زودی'
          },
          helper: <></>
        }
      ]
    },
    {
      name: 'ابزار SERP',
      icon: <SerpToolsIcon />,
      children: [
        {
          name: 'تاریخچه',
          to: '/serp/history',
          helper: (
            <>
              ابزار SERP تقریبا همه چی داخلش داره، به کمک این ابزار می‌تونید
              آنالیز بسیار دقیق صفحه اول گوگل به همراه تحلیل ۱۰ سایت برتر رو
              داشته باشید. معیارهایی مثل سختی کلمه، سابقه جستجوی کلمه، دامین
              آتوریتی، اسپم اسکور، میزان بازدید ماهانه هر سایت، ساختار محتوا و
              ۱۰ ها معیار جذاب دیگه رو داشته باشید تا بتونید بهترین تصمیم رو
              بگیرید. پیشنهاد میشه حتما فیلم{' '}
              <a
                target="_blank"
                rel="noreferrer noopener"
                href="https://help.mizfa.tools/learn-serp/"
              >
                {' '}
                آموزشی ابزار SERP{' '}
              </a>{' '}
              مشاهده کنید تا از امکانات این ابزار شکفت زده بشید.
            </>
          )
        },
        {
          name: 'نمای کلی',
          helper: (
            <>
              تب نمای کلی ترکیبی از اطلاعات مهم تب‌های بررسی نتایج و بریف محتوا
              هست یعنی شما هم یک سری اطلاعات از کلمات دریافت می‌کنید و هم یک سری
              اطلاعات از ۱۰ سایت برتر، اگر قصد دارید خیلی حرفه‌ای ابزار SERP رو
              یاد بگیرید پیشنهاد میکنیم{' '}
              <a
                target="_blank"
                rel="noreferrer noopener"
                href="https://help.mizfa.tools/learn-serp/"
              >
                {' '}
                فیلم آموزش ابزار SERP{' '}
              </a>{' '}
              رو حتما ببینید.
            </>
          ),
          to: '/serp/overview'
        },
        {
          name: 'بررسی نتایج',
          helper: (
            <>
              تب بررسی نتایج جزئیات بیشتر و دقیق تری رو از ده سایت برتر در کلمه
              ای که جستجو کردی بهت نمایش میده، مثل اسپم اسکور، دامین آتوریتی،
              قدرت دامنه، سن دامنه‌ها و کلی اطلاعات جذاب دیگه که مربوط به
              اطلاعات ۱۰ دامنه برتر در SERP هست، اگر تمایل دارید یک رشد عالی در
              سایتتون تجربه کنید پیشنهاد میکنیم{' '}
              <a
                target="_blank"
                rel="noreferrer noopener"
                href="https://help.mizfa.tools/learn-serp/"
              >
                {' '}
                فیلم آموزش ابزار SERP{' '}
              </a>{' '}
              رو حتما ببینید.
            </>
          ),
          to: '/serp/results'
        },
        {
          name: 'بریف محتوا',
          helper: (
            <>
              تب بریف محتوا یکی از بخش های جذاب ابزار SERP هست که برای نوشتن
              مقاله، متن دسته بندی و هر تولید محتوایی بهت کمک میکنه .با کمک این
              بخش میتونی متوجه بشی برای تولید محتوا درباره چی بنویسی، چه تعداد
              کلمه بنویسی، از چه عنوان ها و زیر عنوان هایی استفاده کنی که بهتر
              باشه و کلی اطلاعات جذاب دیگه … هر بخش علامت سوال داره که می‌تونید
              مطالعه کنید ولی بهتره{' '}
              <a
                target="_blank"
                rel="noreferrer noopener"
                href="https://help.mizfa.tools/learn-serp/"
              >
                {' '}
                فیلم ابزار SERP{' '}
              </a>{' '}
              مشاهده کنید تا بتونید نهایت استفاده از این ابزار رو ببرید.
            </>
          ),

          to: '/serp/content-brief'
        }
      ],
      active: true
    },
    {
      name: 'ابزار ایندکسر',
      icon: <IndexerIcon />,
      active: true,
      disabled: false,
      badge: {
        type: 'success',
        text: 'جدید'
      },
      children: [
        {
          name: 'نمای کلی',
          to: '/indexer/overview',
          active: true,
          helper:
            'خلاصهٔ وضعیت ایندکس، سهمیهٔ روزانه و روند درخواست‌ها را در یک نگاه ببینید. با انتخاب بازهٔ زمانی، آمار کارت‌ها و نمودارها به‌روز می‌شود.'
        },
        {
          name: 'درخواست ایندکس',
          to: '/indexer/index',
          active: true,
          helper:
            'از اینجا آدرس‌ها را برای ایندکس به گوگل می‌فرستید — دستی یا با زمان‌بندی sitemap. سهمیهٔ روزانهٔ Indexing API را در کارت بالای صفحه ببینید.'
        },
        {
          name: 'وضعیت ایندکس',
          to: '/indexer/url-inspection',
          active: true,
          helper:
            'وضعیت ایندکس هر URL را با URL Inspection گوگل بگیرید. برای پایش مداوم از تب زمان‌بندی و اطلاع‌رسانی استفاده کنید.'
        },
        {
          name: 'لیست آدرس‌ها',
          to: '/indexer/urls',
          active: true,
          helper:
            'کاتالوگ همهٔ URLهای شناخته‌شده با آخرین وضعیت ایندکس. می‌توانید فیلتر کنید، جستجو کنید یا خروجی بگیرید.'
        },
        {
          name: 'تغییرات',
          to: '/indexer/changes',
          active: true,
          helper:
            'فقط وقتی بازرسی وضعیت ایندکس را نسبت به بازرسی قبلی عوض کند اینجا ثبت می‌شود. اولین بازرسی هر آدرس در این لاگ نیست.'
        },
        {
          name: 'تنظیمات',
          to: '/indexer/settings',
          active: true,
          helper:
            'کلید Service Account گوگل و در صورت نیاز IndexNow را اینجا مدیریت کنید. بدون Owner در Search Console، ایندکس و بازرسی کار نمی‌کند.'
        }
      ]
    },
    {
      name: 'خزش سایت',
      icon: <SiteAuditIcon />,
      newFeatureKey: 'crawl-v2',
      children: [
        {
          name: 'خزش جدید',
          to: '/crawl/history',
          helper: (
            <>
              به کمک <strong>ابزار خزش</strong> شما می‌تونید خیلی{' '}
              <strong>سریع</strong>، <strong>هوشمندانه</strong> و با{' '}
              <strong>دقت بالا</strong> تمام مشکلات سئوی داخلی سایت خودتون رو
              پیدا کنید. بهینه سازی سئوی داخلی به کمک ابزار خزش باعث میشه
              هزینه‌های سئوی خارجی (بک‌لینک) شما کمتر بشه. حتما فیلم آموزشی
              ابزار رو در{' '}
              <a
                href="https://help.mizfa.tools/category/crawl/"
                target="_blank"
                rel="noreferrer noopener"
              >
                این لینک
              </a>{' '}
              مشاهده کنید.
            </>
          ),
        },
        {
          name: 'نمای کلی',
          to: '/crawl/overview',
          helper: (
            <>
              در نمای کلی ابزار خزش شما می‌تونید اطلاعات کلی درباره خزش صورت
              گرفته رو مشاهده کنید، پیشنهاد میشه ابتدا اطلاعات کلی رو بررسی کنید
              تا بتونید یک نگاه کلی از خطاها و اطلاعات سایت پیدا کنید و سپس برای
              مشاهده جزئیات بیشتر وارد بقیه تب‌ها بشید.
            </>
          )
        },
        {
          name: 'فهرست بازبینی',
          to: '/crawl/check-list',
          helper: (
            <>
              فهرست بازبینی به سه بخش خطا، هشدار و اطلاعیه تقسیم شده، خطا مواردی
              هست که اثر زیادی در سئو داره، هشدار موارد قابل توجه هست و اطلاعیه
              باید بررسی بشه و ممکنه خطا باشه و یا نباشه، همینطور سمت راست هر
              مورد سه آیکون{' '}
              <FiArrowUpCircle title="اولویت بالا" className="text-danger" />{' '}
              <FiCircle title="اولویت متوسط" className="text-warning" />{' '}
              <FiArrowDownCircle title="اولویت پایین" className="text-info" />{' '}
              وجود داره ، آیکون{' '}
              <FiArrowUpCircle title="اولویت بالا" className="text-danger" />{' '}
              یعنی موردی که باید بررسی بشه اولویت بالایی داره، آیکون{' '}
              <FiCircle title="اولویت متوسط" className="text-warning" /> یعنی
              اولویت متوسط و آیکون{' '}
              <FiArrowDownCircle title="اولویت پایین" className="text-info" />{' '}
              یعنی اولویت کم
            </>
          )
        },
        {
          name: 'صفحات',
          to: '/crawl/pages',
          helper: (
            <>
              در تب صفحات براساس بودجه خزشی که دارید صفحات شما با دقت بالا بررسی
              شده، اطلاعات هر صفحه به صورت ستون‌ قابل نمایش هست، ستون‌ها
              گروه‌بندی شدن تا بتونید براساس داده‌های تمیزی که وجود داره یک
              بررسی عالی داشته باشید. همچنین می‌تونید از فیلتر پیشرفته براساس
              نیازهاتون صفحات رو فیلتر کنید. راستی هر ستون راهنما داره.
            </>
          )
        },
        {
          name: 'گراف پیوند',
          to: '/crawl/linkgraph',
          helper: (
            <>
              گراف پیوند ترسیم ساختار یک وب سایت در لینک سازی داخلی و درک چگونگی
              ارتباط صفحات مختلف با یکدیگر رو نمایش میده. با تجزیه و تحلیل
              نمودارهای پیوند، موتورهای جستجو می‌تونن ارتباط و کیفیت یک وب سایت
              را از نظر سئو داخلی بهتر بررسی کنن، همینطور پیوند داخلی به
              موتورهای جستجو کمک میکنه تا صفحات سایت شما رو مطابق با آن رتبه
              بندی کنه.
            </>
          )
        },
        {
          name: 'پیوند داخلی',
          to: '/crawl/internal-link',
          helper: (
            <>
              در بخش پیوند داخلی می‌تونید تمام لینک‌های داخلی به همراه متنی که
              دارند مشاهده کنید، بهینه سازی پیوندهای داخلی به کمک اطلاعات و جدول
              زیر کمک بسیار زیادی به سئوی سایت شما میکنه.
            </>
          )
        },
        {
          name: 'پیوند خارجی',
          to: '/crawl/external-link',

          helper: (
            <>
              در این بخش تمام پیوندهای خارجی که درون سایت شما ایجاد شده نمایش
              داده میشه، به کمک پیوند خارجی متوجه میشید که به دامنه‌ها و
              نشانی‌هایی بیشترین لینک خارجی رو دادید.
            </>
          )
        }
      ],
      active: true
    },
    {
      name: 'سرعت صفحه',
      icon: <PageAnalyzeIcon />,
      to: '/analysis',
      newFeatureKey: 'page-speed-v2',
      active: true,
      children: [
        {
          name: 'تاریخچه',
          to: '/analysis/history',
          exact: false,
          active: true,
        },
        {
          name: 'نمای کلی',
          to: '/analysis/overview',

          exact: false,
          active: true,
        },
        {
          name: 'مقایسه',
          to: '/analysis/comparison',
          exact: false,
          active: true,
          badge: {
            type: 'success',
            text: 'جدید'
          }
        },
        {
          name: 'سئوی داخلی',
          to: '/analysis/internal-seo',

          exact: false,
          active: true
        },
        {
          name: 'سرعت',
          to: '/analysis/speed',
          exact: false,
          active: true
        },
        {
          name: 'گزارش CrUX',
          to: '/analysis/crux',
          exact: false,
          active: true,
          badge: {
            type: 'success',
            text: 'جدید'
          },
          helper:
            'داده‌های واقعی کاربران را برای معیارهای Core Web Vitals در سطح صفحه و کل دامنه نمایش می‌دهد.'
        }
      ]
    },
    {
      name: 'ابزار بک‌لینک',
      icon: <BacklinksIcon />,
      active: true,
      to: '/backlink',
      exact: true,
      children: backlinkTabRoutes.children,
      badge: {
        type: 'success',
        text: 'جدید'
      }
    },
    {
      name: 'گزارش گیری',
      icon: <ReportingIcon />,
      children: [
        {
          name: 'گزارش ردیاب',
          to: '/reporting/tracker',
          badge: {
            type: 'success',
            text: 'جدید'
          },
          helper: <></>
        },
        {
          name: 'گزارش سرعت سایت',
          to: '/reporting/page_speed',
          badge: {
            type: 'success',
            text: 'جدید'
          },
          helper: <></>
        },
        {
          name: 'گزارش اختصاصی (به زودی)',
          to: '/reporting/tracker',
          disabled: true,
          helper: <></>
        }
      ],
      active: true
    }
  ]
};

export const financeRoutes = {
  label: 'مالی',
  labelDisable: true,
  children: [
    {
      name: 'مالی',
      icon: 'wallet',
      active: true,
      defaultOpen: true,
      children: [
        {
          name: 'سفارشات',
          to: '/orders/',
          exact: true,
          active: true
        },
        {
          name: 'خرید طرح',
          to: '/prorogate-or-upgrade/',
          exact: false,
          active: true
        },
        {
          name: 'کیف پول',
          to: '#',
          exact: false,
          active: true,
          children: [
            {
              name: 'شارژ کردن',
              to: '/wallet/charge',
              action: 'openChargeWalletModal',
              exact: false,
              active: true
            },
            {
              name: 'کد هدیه',
              to: '/wallet/gift-code',
              action: 'openGiftCodeModal',
              exact: false,
              active: true
            },
            {
              name: 'تراکنش ها',
              to: '/wallet/transactions?wallet_type=1',
              exact: false,
              active: true
            }
          ]
        }
      ]
    }
  ]
};

export const supportRoutes = {
  label: 'پشتیبانی',
  labelDisable: true,
  children: [
    {
      name: 'پشتیبانی',
      icon: 'comments',
      active: true,
      defaultOpen: true,
      children: [
        {
          name: 'پشتیبانی در تلگرام',
          to: 'https://t.me/mizfatools_support',
          target: '_blank',
          exact: true,
          active: true
        },
        {
          name: 'پشتیبانی در بله',
          to: 'https://ble.ir/mizfatools_support',
          target: '_blank',
          exact: true,
          active: true
        },
        {
          name: 'پشتیبانی با AI',
          to: '#!',
          action: 'openAiSupportChat',
          exact: true,
          active: true
        },
        {
          name: 'راهنمای ابزار',
          to: 'https://mizfa.tools/docs/',
          target: '_blank',
          exact: true,
          active: true
        },
        {
          name: 'منتورینگ',
          to: '/support/mentoring',
          exact: false,
          active: true
        }
      ]
    }
  ]
};

export const settingRoutes = {
  label: 'سایر',
  labelDisable: false,
  children: [
    {
      name: 'تنظیمات',
      icon: 'cog',
      newFeatureKey: 'settings-v2',
      active: true,
      defaultOpen: false,
      children: [
        {
          name: 'مدیریت دسترسی',
          to: '/settings/domain_access',
          exact: false,
          active: false
        },
        {
          name: 'تنظیمات AI',
          to: '/settings/ai',
          exact: false,
          active: false,
        },
        {
          name: 'تنظیمات API',
          to: '/settings/api-key',
          exact: false,
          active: false
        },
        {
          name: 'تنظیمات MCP',
          to: '/settings/mcp',
          exact: true,
          active: false,
          disabled: false,
          badge: {
            type: 'success',
            text: 'جدید'
          },
          helper:
            'ابزارهای میزفا را به Cursor، ChatGPT، Codex، Claude و Gemini وصل کنید. آدرس سرور و نمونه تنظیمات همین‌جاست.'
        },
        {
          name: 'تنظیمات ظاهری',
          to: '/settings/appearance',
          exact: false,
          active: false
        },
        // {
        //   name: 'اطلاع رسانی',
        //   icon: 'bell',
        //   to: '/settings/notifications',
        //   exact: true,
        //   active: true
        // },
        {
          name: 'حساب کاربری',
          to: accountServerUrl,
          exact: false,
          active: false
        }
      ]
    }
  ]
};

export default [
  dashboardRoutes,
  // aiAssistantRoutes,
  toolRoutes,
  financeRoutes,
  supportRoutes,
  settingRoutes
];
